export const CITY_PROVINCE_REQUEST = 'CITY_PROVINCE_REQUEST'
export const CITY_PROVINCE_SUCCESS = 'CITY_PROVINCE_SUCCESS'
export const CITY_PROVINCE_FAIL = 'UCITY_PROVINCE_FAIL'

export const CITY_PID_REQUEST = 'CITY_PID_REQUEST'
export const CITY_PID_SUCCESS = 'CITY_PID_SUCCESS'
export const CITY_PID_FAIL = 'CITY_PID_FAIL'